import React from 'react';
import EmptyHeader from '@/components/EmptyHeader';
import error from '@/assets/overview/error.svg';
import { getQueryStringArgs } from '@/utils/url-parse';
import $i18n from '../../i18n';

import './index.less';

const NoFoundPage: React.FC = () => {
  const { reason } = getQueryStringArgs();

  const titles = {
    INTCNN_INVITATION_CODE_NOT_EXIST: $i18n.get({
      id: 'aopf.pages.error.ThisInvitationIsInvalid',
      dm: '此邀请是无效的',
    }),
    INTCNN_INVITATION_CODE_STATUS_ERROE: $i18n.get({
      id: 'aopf.pages.error.INVITATION_EXPIRED',
      dm: '你没有在截止日期内回复',
    }),
    INTCNN_INVITATION_CODE_USED: $i18n.get({
      id: 'aopf.pages.error.INVITATION_USED',
      dm: '邀请已经被使用了',
    }),
    INTCNN_INVITATION_CODE_WITHDRAW: $i18n.get({
      id: 'aopf.pages.error.INVITATION_WITHDRAW',
      dm: '你的邀请被撤回',
    }),
    // 20250827: 更新接口rest/intercnn/inviteCheck为 /rest/intercnn/invitation/detail
    // 统一joinspace和setlein页面的错误状态码, 后端反馈说现接口无“SPACE_FORBIDDEN”错误，
    // 但考虑交接代码怕后端有梳理遗漏逻辑，先保留此状态码
    SPACE_FORBIDDEN: $i18n.get({
      id: 'aopf.pages.error.SPACE_FORBIDDEN.des',
      dm: '此空间是禁止的',
    }),
    INTCNN_INVITATION_CODE_ACCOUNT_CONFUSED: $i18n.get({ id: 'aopf.pages.error.INTCNN_INVITATION_CODE_ACCOUNT_CONFUSED', dm: '邀请无效' }),
  };

  const descriptions = {
    INTCNN_INVITATION_CODE_STATUS_ERROE: $i18n.get({ id: 'aopf.pages.error.INVITATION_EXPIRED.des', dm: '邀请过期' }),
    INTCNN_INVITATION_CODE_USED: $i18n.get({ id: 'aopf.pages.error.INVITATION_USED.des', dm: '邀请被使用' }),
    INTCNN_INVITATION_CODE_WITHDRAW: $i18n.get({
      id: 'aopf.pages.error.INVITATION_WITHDRAW.des',
      dm: '邀请被撤回',
    }),
    SPACE_FORBIDDEN: $i18n.get({ id: 'aopf.pages.error.SPACE_FORBIDDEN', dm: '空间被禁止' }),
    INTCNN_INVITATION_CODE_NOT_EXIST: $i18n.get({ id: 'aopf.pages.error.InvalidInvitation', dm: '邀请无效' }),
    INTCNN_INVITATION_CODE_ACCOUNT_CONFUSED: $i18n.get({ id: 'aopf.pages.error.INTCNN_INVITATION_CODE_ACCOUNT_CONFUSED.desc', dm: '邀请无效' }),
    
  };

  const actions = {
    SPACE_FORBIDDEN: $i18n.get({ id: 'aopf.pages.error.action.msg.space', dm: '请联系你的管理员' }),
    INTCNN_INVITATION_CODE_ACCOUNT_CONFUSED: $i18n.get({ id: 'aopf.pages.error.INTCNN_INVITATION_CODE_ACCOUNT_CONFUSED.action' }),
    INTCNN_INVITATION_CODE_NOT_EXIST: $i18n.get({ id: "aopf.pages.error.action.VerifyAction.msg"}),
    INTCNN_INVITATION_CODE_WITHDRAW: $i18n.get({ id: "aopf.pages.error.action.confirm.msg"}),
    DEFAULT: $i18n.get({
              id: 'aopf.pages.error.action.msg.invitation',
              dm: '请联系您的邀请人重新发送邀请',
            })
  }

  return (
    <div className="error-container">
      <EmptyHeader />
      <div className="page-content">
        <div className="error-logo">
          <img src={error} alt="" />
        </div>
        <div className="error-msg">
          <div className="error-content">
            <h2>{$i18n.get({ id: 'aopf.pages.error.h2.error', dm: '错误' })}</h2>
            <p className="error-title">{titles[reason]}</p>
            <div className="description-title">
              {$i18n.get({ id: 'aopf.pages.error.Cause.Description', dm: '原因说明' })}
            </div>
            <p className="error-description">{descriptions[reason] || reason}</p>
            <div className="description-title">
              {$i18n.get({ id: 'aopf.pages.error.Suggestion.for.Action', dm: '行动建议' })}
            </div>
            <p className="error-action">
              { actions[reason] || actions.DEFAULT }
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoFoundPage;